import { connectAppStore } from "../../../Store/AppStore";
import PageDependencies from "../../../Feature/PageDependencies";

const BatchProcess = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        useParams,
        layoutManager,
        useReducerSmart,    
        BaseForm,
        getData,
        BindedInput,
        BindedCheckBox,
        toastPrint,
        getAppStore,
        htmlToReactParse,
        pageProfile,
        loaModelFromApi,
        guid,
        FormValidate,
    } = PageDependencies();
    let debug = layoutManager.Layout_GetDebugModel(props);
    const defaultParams = pageProfile.getDefaultParams(useParams());
    const [init, setInit] = useState(false);
    const [pageStatus, setPageStatus] = useState({
        validated: false,
        validating: false,
        submitButtonDisabled: true
    });
    const [validationResults, setValidationResults] = useState({
        state:false,
        message:"",
        resultItems:[]
    });
    const [reloadForm, setReloadForm] = useState("");
    const {redirectUrl} = defaultParams;
    const defaultViewModel = {
        ...defaultParams,
        filePath: "",
        useCachedMode: true,
        isCleanupEnabled: false,
    };
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart(defaultViewModel);
    const [loading, setLoading] = useState({ isLoading: false, text: "" });
    const [appStoreState, appStoreDispatch] = getAppStore(props);
    //add model get url here if not using default model
    const getUrl = "api/DefaultModel/Accessor/Get";
    //add model post url here 
    const postUrl = "api/AnalysisResult/Accessor/BatchProcess";
    const postUrlValidate = "api/AnalysisResult/Accessor/BatchProcessExcelFileValidate";
    const validateMethods = {
        //add form property validate here
       recipientEmailAddresses:(value)=>{return FormValidate.validateTextRequired(value, "Recipient Email Addresses", undefined, false, 500)},
       simulationResultsArchiveName:(value)=>{return FormValidate.validateTextRequired(value, "Simulation Results Archive Name", undefined, false, 500)},
       filePath:(value)=>{return FormValidate.validateTextRequired(value, "File", 'Must select a Excel file', false, 500)},
    };
    const formValidate = new FormValidate(useState(validateMethods), useState(), useState(), useState(), false);

    useEffect(()=>{    
        layoutManager.Layout_Headter_Footer_SideBar(props);
        loaModelFromApi.loadDefault(true, getUrl, viewModel, dispatchViewModel, setLoading, "Loading data", appStoreDispatch, (newViewModel)=>{
            //callback after loaded default model
            dispatchViewModel({...newViewModel, recipientEmailAddresses: newViewModel.userName, simulationResultsArchiveName: newViewModel.projectName});
        }, setInit);
    },[]);

    useEffect(()=>{
        try{
             if(viewModel.filePath !== undefined && viewModel.filePath !== ""){
                const input = document.getElementById("formFile");
                const fReader = new FileReader();
                fReader.readAsDataURL(input.files[0]);
                fReader.onloadend = function(event){
                    const fileData = event.target.result;
                    const newModel = {...viewModel, fileDataBase64: fileData};                  
                    dispatchViewModel(newModel); 
                    setPageStatus({...pageStatus, validating: true, submitButtonDisabled: true});       
                    getData.processPost(true, postUrlValidate, newModel).then((validateResponse)=>{                
                        if(validateResponse.state === true){
                            setPageStatus({...pageStatus, validating:false, validated: true, submitButtonDisabled: false});                           
                        }else{
                            setPageStatus({...pageStatus, validating:false, validated: true, submitButtonDisabled: true});
                        }
                        setValidationResults(validateResponse);
                    });            
                }
            }   
        }
        catch{
            setPageStatus({validating:false, validated: false, submitButtonDisabled: false});
            toastPrint.printErrorMessage("Error happens during file validation");
        }      
    },[viewModel.filePath]);

    const generateSpace = (level)=> {
        let space = "";
        for(let i = 0; i < level; i++) {
            space = space + "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        }
        return space;
    }

    const printResultItem = (item, level) =>{
         const p = htmlToReactParse(generateSpace(level) + item.title + ":&nbsp;" + item.content);
         return <div key = {guid.newGuid()}>
            <p key = {guid.newGuid()}>{p}</p>
            {item.subItems.map((t)=>{
                return printResultItem(t, level + 1);
            })}
         </div>
    }

   return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            <BaseForm
                id="BatchProcess"
                icon="pe-7s-user"
                loading={loading}
                init={init}
                setReload={setReloadForm}
                setLoading={setLoading}
                submitButtonAndStay = {{text:"Submit", postUrl: postUrl, redirectUrl: "", disabled: pageStatus.submitButtonDisabled, submitCallBackResponse: ()=>{
                    setPageStatus({validating:false, validated: false, submitButtonDisabled: true}); 
                    dispatchViewModel({viewModel, filePath: "", fileDataBase64: ""}); 
                }}}
                cancelButton={{ redirectUrl: redirectUrl }}
                data={viewModel}
                validate ={formValidate}
                title = "Batch Process"
                subTitle={""}
            >           
                <div className="form-row row">
                     <div className="col-12">
                        <div className="position-relative form-group">
                            <label>Project Name: <b>{viewModel.projectName}</b></label>                 
                        </div>
                    </div>   
                     <div className="col-12">
                        <div className="position-relative form-group">
                            <label>Design Variation Name: <b>{viewModel.designVariationName}</b></label>                 
                        </div>
                    </div>   
                     <div className="row">
                        <div className="col-6">                      
                            <div className="position-relative form-group">
                                <label htmlFor="RecipientEmailAddresses">Recipient Email Addresses <span style={{color:"red"}}>*</span></label>
                                <BindedInput id="RecipientEmailAddresses" name="RecipientEmailAddresses" type="text" validate ={formValidate} className="form-control" binding={[viewModel, "recipientEmailAddresses", bindingViewModel]}></BindedInput>                      
                            </div>
                        </div>   
                    </div>
                  <div className="row">
                        <div className="col-6">
                            <div className="position-relative form-group">
                                <label htmlFor="SimulationResultsArchiveName">Simulation Results Archive Name <span style={{color:"red"}}>*</span></label>
                                <BindedInput id="SimulationResultsArchiveName" name="SimulationResultsArchiveName" type="text" validate ={formValidate} className="form-control" binding={[viewModel, "simulationResultsArchiveName", bindingViewModel]}></BindedInput>                      
                            </div>
                        </div>    
                  </div> 
                  {"debug" === "hidden" &&
                   <div className="row">
                    <div className="col-6">
                    <div className="custom-checkbox custom-control">
                      <BindedCheckBox
                          id="UseCachedMode" 
                          name="UseCachedMode"
                          className="custom-control-input"
                          binding={[viewModel, "useCachedMode", bindingViewModel]}
                      ></BindedCheckBox>
                      <label style={{marginLeft:"5px"}} htmlFor="UseCachedMode" className="custom-control-label">Use Cached Mode</label>
                    </div>                 
                  </div>
                </div>                
                  }
               <div className="row">
                    <div className="col-6">
                    <div className="custom-checkbox custom-control">
                      <BindedCheckBox
                          id="IsCleanupEnabled" 
                          name="IsCleanupEnabled"
                          className="custom-control-input"
                          binding={[viewModel, "isCleanupEnabled", bindingViewModel]}
                      ></BindedCheckBox>
                      <label style={{marginLeft:"5px"}} htmlFor="IsCleanupEnabled" className="custom-control-label">Clean up after analysis</label>
                    </div>                 
                  </div>
                </div>    
                <div className="row">             
                    <div className="col-6">                           
                        <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">Upload Excel File <span style={{color:"red"}}>* </span>{pageStatus.validating === true ? "Validating..." : ""}</label>
                            <BindedInput  type="file" id="formFile" accept="xlsx/*" validate ={formValidate} className="form-control" disabled={pageStatus.validating} binding={[viewModel, "filePath", bindingViewModel]}></BindedInput>    
                        </div>
                    </div>
                </div>
                </div>
                {pageStatus.validated && 
                 <div className="main-card mb-3 card" >
                    <div className="form-row row">
                        <h6 style={{marginBottom:"15px"}}>File validation results</h6>                      
                        <p>State: <b style={{color:validationResults.state === true ? "green" : "read"}}>{validationResults.state === true ? "Succeed" : "Error"}</b> Message: {validationResults.message}</p>           
                        <h6 style={{marginBottom:"15px"}}>Details</h6>    
                        {validationResults.resultItems !== undefined && validationResults.resultItems.length > 0 && validationResults.resultItems.map((t)=>{
                            return printResultItem(t, 0);
                        })}
                    </div>
                </div>  
                }
            </BaseForm>
        </Fragment>
    );
}
export default connectAppStore(BatchProcess);